import Action from '../action';

export const COLUMN_VISIBLE_TOGGLED = 'COLUMN_VISIBLE_TOGGLED';
export const COLUMN_ORDERBY = 'COLUMN_ORDERBY_ADDED';
// export const COLUMN_SELECTED = 'COLUMN_SELECTED';
// export const COLUMN_UNSELECTED = 'COLUMN_UNSELECTED';
export const COLUMN_SECURITY_GROUPS_SET = 'COLUMN_SET_SECURITY_GROUPS';
export const COLUMN_ATTRIBUTES_SET = 'COLUMN_ATTRIBUTES_SET';

export const SET_COLUMN_VISIBILTY = '@table-columns/SET_COLUMN_VISIBILTY';

export const toggleColumn = column => Action(COLUMN_VISIBLE_TOGGLED, column);
export const setAttributes = attributes => Action(COLUMN_ATTRIBUTES_SET, attributes);
export const setSecurityGroups = securityGroups => Action(COLUMN_SECURITY_GROUPS_SET, securityGroups);
export const setColumnVisiblity = user => Action(SET_COLUMN_VISIBILTY, user);
// export const columnSelected = column => Action(COLUMN_SELECTED, column);
// export const columnUnSelected = column => Action(COLUMN_UNSELECTED, column);

